import { Kpi, ChartCard, Bars, LineTrend, HBar } from "./widgets";

export default function FieldAnalytics({ data }) {
  const ratingAvg = (() => {
    let tot = 0, n = 0;
    (data.rating_distribution || []).forEach((r) => { tot += r.stars * r.count; n += r.count; });
    return n ? (tot / n).toFixed(2) : "—";
  })();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="field-kpis">
        <Kpi label="Completed" value={data.completed_count || 0} accent="#10B981" testId="kpi-jc-completed" note="In selected window" />
        <Kpi label="Avg turnaround" value={data.avg_turnaround_hours || 0} unit="hrs" accent="#F59E0B" testId="kpi-jc-turnaround" />
        <Kpi label="Photo compliance" value={data.photo_compliance_pct || 0} unit="%" accent="#1FB6C1" testId="kpi-jc-photos" note="Completed jobs with photos" />
        <Kpi label="Avg rating" value={ratingAvg} unit={ratingAvg !== "—" ? "★" : ""} accent="#A78BFA" testId="kpi-jc-rating" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ChartCard title="Job cards by phase" desc="All non-archived jobs" testId="chart-jc-phases">
          <Bars data={data.jobcards_by_phase} xKey="phase" yKey="count" color="#F59E0B" />
        </ChartCard>
        <ChartCard title="Customer rating distribution" desc="All rated jobs" testId="chart-jc-ratings">
          <Bars data={data.rating_distribution} xKey="stars" yKey="count" color="#10B981" />
        </ChartCard>
        <ChartCard title="Daily completions" desc="Jobs completed per day" testId="chart-jc-completions">
          <LineTrend data={data.completions_trend} xKey="date" yKey="count" color="#F59E0B" />
        </ChartCard>
        <ChartCard title="Technician utilisation" desc="Completed jobs per tech" testId="chart-jc-techs">
          <HBar data={data.tech_utilisation} labelKey="name" valueKey="jobs" color="#1FB6C1" />
        </ChartCard>
      </div>
    </div>
  );
}
